export default {
  created() {
    this.$store.dispatch('SET_ORDER_STEP', `3-default-more-photos`);
  }
};